
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefb24"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefb24"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7pcrU", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $56448658f9d78b6d$export$6503ec6e8aabbaf; }, function (v) { return $56448658f9d78b6d$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $56448658f9d78b6d$export$f7ad0328861e2f03; }, function (v) { return $56448658f9d78b6d$export$f7ad0328861e2f03 = v; });
var $56448658f9d78b6d$export$6503ec6e8aabbaf;
var $56448658f9d78b6d$export$f7ad0328861e2f03;
"use strict";
var $56448658f9d78b6d$var$mapping = new Map();
function $56448658f9d78b6d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$56448658f9d78b6d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $56448658f9d78b6d$var$resolve(id) {
    var resolved = $56448658f9d78b6d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$56448658f9d78b6d$export$6503ec6e8aabbaf = $56448658f9d78b6d$var$register;
$56448658f9d78b6d$export$f7ad0328861e2f03 = $56448658f9d78b6d$var$resolve;

});

var $49357fffb7f4b4bb$exports = {};

(parcelRequire("7pcrU")).register(new URL("", import.meta.url).toString(), JSON.parse('["92uv5","index.16aa5ba8.js","laPmH","Grocery.f68e8ba1.js"]'));


//# sourceMappingURL=index.runtime.2281f733.js.map
